import { render, staticRenderFns } from "./expertExtraction.vue?vue&type=template&id=f183bef0&scoped=true"
import script from "./expertExtraction.vue?vue&type=script&lang=js"
export * from "./expertExtraction.vue?vue&type=script&lang=js"
import style0 from "./expertExtraction.vue?vue&type=style&index=0&id=f183bef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f183bef0",
  null
  
)

export default component.exports